"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformSchematicReference = void 0;
const TransformSchematicDrawing_1 = require("./TransformSchematicDrawing");
const TransformMultiInstanceSchematic_1 = require("./TransformMultiInstanceSchematic");
class TransformSchematicReference extends TransformSchematicDrawing_1.TransformSchematicDrawing {
    constructor(parent, props) {
        super(parent, {
            layers: props.layers,
            drawing: {
                type: 'schref',
                name: props.name,
                file: props.file,
                designId: null,
                drawModule: { ref: String(props.transformModule.deduplicationKey) },
            },
        });
        this._transformModule = props.transformModule;
        this._targetSchematic = props.targetSchematic;
        this._layers = props.layers;
        this._name = props.name;
        this._file = props.file;
    }
    get dependencies() {
        const deps = [this._transformModule];
        if (this._targetSchematic) {
            deps.push(this._targetSchematic);
        }
        return deps;
    }
    compile() {
        let designId = null;
        if (this._targetSchematic) {
            const targetParent = this._targetSchematic.parent;
            if (targetParent instanceof TransformMultiInstanceSchematic_1.TransformMultiInstanceSchematic) {
                designId = targetParent.designId;
            }
            else {
                designId = this._targetSchematic.designId;
            }
        }
        return {
            layers: this._layers,
            drawing: {
                type: 'schref',
                name: this._name,
                file: this._file,
                designId,
                drawModule: this._transformModule.compiled,
            },
        };
    }
}
exports.TransformSchematicReference = TransformSchematicReference;
//# sourceMappingURL=TransformSchematicReference.js.map